/**
 * Copyright (c) 2025-2026 eBUCIS, LLC. All rights reserved.
 *
 * AppCopyright - footer copyright line with an always-current year.
 *
 * Single source of truth for the "© <year> ..." notice rendered in the main app
 * shell (Layout) and the auth shell (AuthLayout), so the year is computed at
 * render time and never goes stale. The `as` prop preserves each call site's
 * existing element (span vs p) so no layout/spacing shifts.
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import PropTypes from 'prop-types'

const AppCopyright = ({ as: Tag = 'span', className = '' }) => {
  return (
    <Tag className={className}>
      &copy; {new Date().getFullYear()} eBUCIS, LLC. All rights reserved.
    </Tag>
  )
}

AppCopyright.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string
}

export default AppCopyright
